/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2018 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
import AddressFormDataReduced from "./AddressFormDataReduced";
import {IAddressData} from "@connox/typescript-library";

export default class AddressFormData extends AddressFormDataReduced implements IAddressData {
  public get street(): string {
    return this.form.Street.value;
  }

  public get number(): string {
    return this.form.Number.value;
  }

  public get zip(): string {
    return this.form.Zip.value;
  }

  public get city(): string {
    return this.form.City.value;
  }

  public get countryCode(): string {
    return this.form.Country.value;
  }

  public get dateOfBirth(): string {
    return this.form.DateOfBirth.value;
  }

  public get state(): string {
    return this.form.State.value;
  }

  public get company(): string {
    return this.form.Company.value;
  }

  public get department(): string {
    return this.form.Department.value;
  }

  public get phone(): string {
    return this.form.PhoneNo.value;
  }

  public get title(): string {
    return this.form.Title.value;
  }

  public get vatNumber(): string {
    return this.form.VatNumber.value;
  }

  constructor(form: IAddressForm) {
    super(form);
  }

  public toJSON(): IAddressData {
    const reduced = this.toJSONReduced();
    const extended = {
      city: this.city,
      company: this.company,
      countryCode: this.countryCode,
      dateOfBirth: this.dateOfBirth,
      department: this.department,
      number: this.number,
      phone: this.phone,
      state: this.state,
      street: this.street,
      title: this.title,
      zip: this.zip,
    };

    return Object.assign({}, reduced, extended);
  }
}

export enum AddressType {
  DELIVERY = "DeliveryAddress",
  INVOICE = "InvoiceAddress",
}

export interface IAddressForm extends HTMLFormElement{
  City: HTMLInputElement;
  Company: HTMLInputElement;
  Country: HTMLSelectElement;
  DateOfBirth: HTMLInputElement;
  Department: HTMLInputElement;
  Email: HTMLInputElement;
  FirstName: HTMLInputElement;
  Gender: HTMLInputElement;
  LastName: HTMLInputElement;
  Number: HTMLInputElement;
  PhoneNo: HTMLInputElement;
  State: HTMLSelectElement;
  Street: HTMLInputElement;
  Title: HTMLInputElement;
  VatNumber: HTMLInputElement;
  Zip: HTMLInputElement;
}
